<template>
	
<div class="default-bg">
	<normalBar title="选择付款方式" path= '/orderManager/1'></normalBar>
	
	<ul class="pay-list">
		<li v-if="isWXUA">
			<div class="pay-items">
				<span class="checkbox-group">
					<input type="radio" class="input-checkbox" v-model="payTypes"  value="6">
					<span class="icon-checkbox"></span>
				</span>
				<div>
					<span class="icon-wx"></span>
					微信安全支付
				</div>
			</div>
		</li>
		<li>
			<div class="pay-items">
				<span class="checkbox-group">
					<input type="radio" class="input-checkbox" v-model="payTypes" value="2">
					<span class="icon-checkbox"></span>
				</span>
				<div>
					<span class="icon-zfb"></span>
					支付宝支付
				</div>
			</div>
		</li>
	</ul>

	<button type="button" class="btn-sure" @click="payOrder">确认</button>
</div>

</template>

<script>
	import normalBar from '@/components/common/navbar/normalBar'
	import pingpp from 'pingpp-js'
	import api from '@/api/api'
	import { mapState } from 'vuex'
  import payHelper from '@/js/payHelper'
  import commonApi from '@/api/common/api.common'
	// ;6-微信 公众号支付;8-微信 WAP 支付
	export default {
		data(){
			return {
				payTypes: '',
				submitLoading: true
			}
		},
		computed: {
	      	isWXUA () {
	        	return this.utils.isWXUA()
	      	},
	      	isWxLogin(){
	      		return this.utils.isWxLogin()
	      	},
    	},
		components: {
			normalBar
		},
		mounted(){
			if(this.isWxLogin){
      			this.payTypes =  6;
  			}else {
  				this.payTypes = 2;
  			};
		},
		methods: {
			payOrder(){

				let self = this;
				if(!this.submitLoading) return false;
				this.submitLoading = false; 
				
				let payNo = self.$route.params.payNo;

				if(self.payTypes == '') return false;
				
				if(self.isWXUA && self.payTypes == 2){
//					 window.location.href= window.location.origin+'/payZfb/'+payNo;
					self.$router.push({
						path: '/payZfb/'+payNo
					})
				}else {
					if(!self.isWxLogin && self.payTypes == 6){
						self.payTypes = 8;
					}
          			commonApi.getPayInfo({
						cancelUrl: window.location.origin+'/#/paySucSure/'+payNo,//	取消支付返回的url	string	
						payNo: payNo,//	支付号	string	
						successUrl: window.location.origin+'/#/paySucSure/'+payNo,
						payType: self.payTypes
					},function(respond){
//						let parameters = json.body.data;



						if (self.payTypes === 8) { // H5 to wxPay
              let redirect_url = '&redirect_url='+encodeURI(window.location.origin+'/#/paySucSure/'+payNo)
              payHelper.dealPay('WXH5', respond.body.data.content+redirect_url)

            } else if(self.payTypes === 6) { // wxPay

              var content = JSON.parse(respond.body.data.content)
              payHelper.dealPay('WX', content, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok" ) {
                  self.$router.push({
                    path: '/paySuccess/'+respond.body.data.merchantId
                  })
                } else {
                  self.$router.push({
                    path: '/paySucSure/'+payNo
                  })
                }
              })

            } else if(self.payTypes === 2) { // H5 to aliPay
              payHelper.dealPay('AliH5', respond.body.data.content)
            }

					})
					setTimeout(function(){self.submitLoading = true; },3000);
				}
				
			},
		}

	}
</script>
<style lang="scss">	
    @import '../../assets/css/mixin';
	
	.pay-list {
		margin-top: pxToRem(20px);
		padding-left: pxToRem(50px);
		background-color: #fff;

		li {
			padding: pxToRem(40px) 0;

			.pay-items {
				display: flex;
				align-items: center;

				.checkbox-group {
					width: pxToRem(36px);
					height: pxToRem(38px);
				}
			}
			
			&:not(:last-of-type){
				border-bottom: 1px solid #BDBDBD;
			}
		}
	}

	.btn-sure {
		margin: pxToRem(100px) auto;
		display: block;
		width: pxToRem(656px);
		height: pxToRem(100px);
		color: #fff;
		background-color: #D8331D;
		border: none;
		font-size: pxToRem(28px);
	}


</style>


// WEBPACK FOOTER //
// payTypes.vue?11a0b4d6